export default __webpack_public_path__ + "static/media/web3.fcd50c84.svg";